import * as React from 'react';

import {getInteractionComponent} from './helpers';
import type {InteractionData} from './types';

import styles from './interaction-modal.module.css';

type Props = {
    data: InteractionData;
    onCancel: () => void;
};

export function InteractionPage(props: Props) {
    const Component = getInteractionComponent(props.data, props.onCancel);

    return (
        <div className='full-height'>
            <div className={styles['stage-content']}>{Component}</div>
        </div>
    );
}
